const toTitleCase = (string) =>
  string
    .toLowerCase()
    .split(' ')
    .map((c) => `${c.charAt(0).toUpperCase()}${c.substring(1)}`)
    .join(' ');

export default toTitleCase;
